<template>
  <div class="nch--blog-category header" :style="`--category-color: ${category.color}`">
    <img class="nch--blog-category featured-image" v-if="image" :src="image" alt="">
    <div class="nch--blog-container">
      <h2 class="nch--blog-title">{{ category.translation.name }}</h2>
      <p v-html="category.translation.description"></p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  props: {
    value: {
      type: Object,
      description: 'Category object',
      required: true,
    },
  },
  computed: {
    category() {
      return this.value;
    },
    image() {
      if (this.category.featured_image) {
        const url = this.getImageUrl(this.category.featured_image);
        return url;
      }
      return null;
    },
  },
  methods: {
    getImageUrl(upload, size = 'original') {
      if (!upload) return '';
      if (typeof upload === 'string') return upload;
      if (upload.urls && upload.urls[size]) return upload.urls[size];
      
      const { host, original_file: file } = upload;
      const isS3 = window.Laravel && window.Laravel.is_s3;
      if (isS3) {
        return `${window.Laravel.s3_url}/${host}/${size}/${file}`;
      }
      return `/storage/${host}/${size}/${file}`;
    },
  },
};
</script>

<style scoped>
.nch--blog-category.header {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 1rem;
  justify-content: center;
  align-items: center;
}
.nch--blog-category.featured-image{
  max-height: 500px;
  max-width: 100%;
  border-radius: 8px;
}
.nch--blog-category .nch--blog-container {
  width: 100%;
  text-align: left;
}
.nch--blog-category.header h2.nch--blog-title {
  color: var(--blog-text);
  font-size: 2.5rem;
  text-align: left;
  width: 100%;
  margin-top: 1rem;
}
@media (max-width: 900px) {
  .nch--blog-category.header h2.nch--blog-title {
    font-size: 2rem;
  }
}
.nch--blog-category .nch--blog-container h2::after{
  content: "";
  display: block;
  width: 30%;
  height: .2rem;
  background-color: var(--category-color);
}
</style>
